import { useRef } from 'react';
import { getIsMobileDevice } from 'src/utils/device';

export const useIsMobileDevice = () => {
  return useRef<boolean | undefined>(getIsMobileDevice());
};
